import map from 'lodash/map';
import Backbone from 'backbone';
import User from './user.js';

// import userStore from 'zoomforth_zf/appglobals/user.js';



var UsersByAccount = Backbone.Collection.extend({
      
  url: function(){
    return '/api/users';
  },
  
  initialize: function(models, { permissionDefs }={}) {
    this.startedFetching = false;
    this.loaded = false;
    this._deferred = new $.Deferred();
    this.permissionDefs = permissionDefs;
  }, 
  
  start: function(bootstrapData) {
    var myBootstrapData = typeof bootstrapData !== 'undefined' ? bootstrapData : null;
    var me = this;
    
    if(this.loaded || this.startedFetching) {
      return this._deferred.promise();
    }
    
    if (myBootstrapData && !this.loaded) {
      this.set(map(myBootstrapData, attrs => new User(attrs, { permissionDefs:this.permissionDefs })));
      this.loaded = true; 
      this._deferred.resolve();

    } else if(!this.loaded && !this.startedFetching) {
      this.startedFetching = true;
      this.fetch({ permissionDefs:this.permissionDefs }).done(function() {
        me.loaded = true; 
        me._deferred.resolve();
      });
    }
    return this._deferred.promise();
  },
  
  getUserAttr(user, attr) {
    if (this.get(user)) {
      return this.get(user).get(attr);
    }
    return undefined;
  },

  getNameById: function(userId) {
    return this.getUserAttr(userId, 'name');
  },
  
  getUserList: function() {
    var userList = [];
    if (this.loaded) {
      userList = this.map();
    } 
    return userList;
  },

  getAdmins() {
    return this.filter(function(user){
      return user.canViewAllPages();
    });
  },
  
  getAssignableUsers: function(){
    return this.filter(function(user){
      return !user.canViewAllPages();
    });
  },
  
  getSenders: function() {
    return this.filter(function(user) {
      return user.isSenderRole();
    });
  }, 
  
  model: function(attrs, { permissionDefs, ...opts }) {
    return new User(attrs, { permissionDefs, ...opts });
  }
  
});


export default UsersByAccount;
